import { HoldingDistributionResultModel } from '/@/api/exchangeService/model/holding';
import { DROTypeEnum, ProductTypeEnum } from '/@/enums/exchangeServiceEnum';

export enum TradeError {
  ORDER_LIST_EMPTY = 'ORDER_LIST_EMPTY',
  NO_ACCOUNT_INFO = 'NO_ACCOUNT_INFO',
}

export enum SoTradeDirection {
  Sell = 0,
  Buy = 1,
}

export interface SoOrderItem {
  refCode: string; // 上游关联字段 txId
  productCode: string; // 产品编码
  totalShares?: string; // 交易份额
  orderDirection?: SoTradeDirection; // 订单方向，0: 卖, 1: 买
  bidPrice: string; // 出价
  payload?: string; // 透传字段
}

export interface SubmitSoOrderParams {
  memberCode?: string; // 会员账号
  tradingAccountCode?: string; // 交易账号
  source: string; // 来源, 字母全大写，如M-Terminal,传入MT
  txId: string; // 事务Id，上游自定义，用来做幂等，或分布式事务
  orderList: SoOrderItem[]; // 委托订单保存请求对象
}

export interface AoOrderItem extends Pick<SoOrderItem, 'refCode' | 'productCode' | 'payload'> {
  buyShares?: string; // 买入份额
}
export interface SubmitAoOrderParams {
  tradingAccountCode?: string; // 交易账号
  source: string; // 来源, 字母全大写，如M-Terminal,传入MT
  txId: string; // 事务Id，上游自定义，用来做幂等，或分布式事务
  orderList: AoOrderItem[]; // 委托订单保存请求对象
}

export interface OrderItem {
  id: number;
  productCode: string; // 产品编码
  refCode: string; // 关联字段
  orderCode: string; // 订单编码
  orderStatus: number; // 0:初始化，1:交易中，2:成功，3:失败，4:取消
  orderDirection: SoTradeDirection; // 0:SELL,1:BUY
  bidPrice: number; // 每手出价
  totalShares: number; // 总份额
  remainShares: number; // 剩余份额
  payload: string; // 透传字段
  createTime: Record<string, unknown>; // 创建时间
  updateTime: Record<string, unknown>; // 更新时间
}

// SO报价表返回值
export interface ProductMarketInfo {
  sellOrders: OrderItem[]; // SO卖单
  buyOrders: OrderItem[]; // SO买单
}

// SO转让 所选产品组合分布图请求参数
export interface ProductDistributionReqsItem {
  productCode: string;
  share: number;
}

// SO转让 所选产品组合分布图返回值
export type TransferDistributionResultModel = HoldingDistributionResultModel;

// SO转让 所选产品收益折线图请求参数
export type ProductGroupShareReqsItem = ProductDistributionReqsItem;

// SO转让 所选产品收益折线图返回值
export interface ProductGroupRevenueItem {
  acfShare: number; // 实际收入分成 每日收益
  pcfShare: number; // 预测收入分成 每日累计PCF
  dataDate: string; // 日期 yyyy-mm-dd
}

export interface TransactionTimeType {
  day: string;
  numVal: number;
  indexOfYear: number;
  isTradeDay: boolean;
  tradeTimeSpan: string;
  indexOfWeek: number;
  feeRateChanged: boolean;
}

export interface TradeFeeParams {
  offeringStage: DROTypeEnum;
  productType: ProductTypeEnum;
}

export interface FindProBaseInfo {
  productCode: String;
}

export interface GetAvailableShares {
  productCode: String;
  tradingAccountCode: String;
}
